<div *ngFor="let item of users">
  <mat-card
    class="list-call-item clickable"
    matRipple
    (click)="selectUser(item)"
  >
    <mat-card-title>
      <b>{{ item.name }}</b>
    </mat-card-title>

    <div style="margin-bottom: 0">
      <p>
        <b><small>Email:</small></b
        ><br />
        {{ item.email }}
      </p>
      <p>
        <b><small>Telefone:</small></b
        ><br />
        {{api.nineExtra(item.mobile) | mask: api.phoneMask}}
      </p>
    </div>
  </mat-card>
</div>
